module.exports = __webpack_public_path__ + "fonts/licensed/tenon-light.woff2";